class GmVideoModal extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.showVideoBtn = this.querySelector("#video-btn");
        this.videoModal = this.querySelector("#video-modal");
        this.closeVideoBtn = this.querySelector("#close-btn");
        this.video = this.querySelector("video");

        this.showVideoBtn.addEventListener("click", () => {
            this.videoModal.showModal();
            document.body.style.overflow = "hidden";

            if (this.video) {
                this.video.currentTime = 0;
                this.video.play();
            }
        });

        this.closeVideoBtn.addEventListener("click", () => this.videoModal.close());

        this.videoModal.addEventListener("click", (event) =>{
            const rect = this.videoModal.getBoundingClientRect();
            const isInModal = 
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom;
            if (!isInModal){
                this.videoModal.close();
            }
        })

        this.videoModal.addEventListener("close", () => {
            if (this.video) {
                this.video.pause();
                this.video.currentTime = 0;
            }

            document.body.style.overflow = "auto";
        })
    }
}

customElements.define('gm-video-modal', GmVideoModal);